<div id="int-todos-main" class="w-full h-full" #todoMain>
  @if (!api.hasPermission('kiosk_mode')) {
    <app-internal-toolbar [title]="'internal.todos.title' | translate">
      <p-iconfield
        center
        class="min-w-80 desktop"
        id="search-field"
        [class.highlight]="highlightedTodos() != undefined && !showTodoMenu() && !isMoving()"
      >
        <p-inputicon>
          <mat-icon>search</mat-icon>
        </p-inputicon>
        <input
          class="w-full"
          #searchInput
          type="text"
          pInputText
          [placeholder]="'general.searchPlaceholder' | translate"
          (keyup)="searchFilter.set($event.target.value)"
          (keydown.enter)="searchInput.blur()"
        />
        @if (searchInput.value) {
          <p-inputicon
            class="cursor-pointer"
            (click)="searchInput.value = ''; searchFilter.set('')"
          >
            <mat-icon>close</mat-icon>
          </p-inputicon>
        }
      </p-iconfield>

      <div actions class="flex flex-row items-center gap-2 mr-2">
        <p-toggleswitch [ngModel]="true" (onChange)="toggleAutoReload($event.checked)" />

        <mat-icon>refresh</mat-icon>
      </div>

      @if (api.hasPermission('create_todos')) {
        <reactive-button
          actions
          [label]="'internal.todos.newTodo' | translate"
          icon="add"
          variant="outlined"
          (onClick)="openTodo()"
        ></reactive-button>
      }
    </app-internal-toolbar>
  }

  <p-iconfield
    center
    class="min-w-80 mobile"
    id="search-field"
    [class.highlight]="highlightedTodos() != undefined && !showTodoMenu() && !isMoving()"
  >
    <p-inputicon>
      <mat-icon>search</mat-icon>
    </p-inputicon>
    <input
      class="w-full"
      #searchInput
      type="text"
      pInputText
      [placeholder]="'general.searchPlaceholder' | translate"
      (keyup)="searchFilter.set($event.target.value)"
      (keydown.enter)="searchInput.blur()"
    />
    @if (searchInput.value) {
      <p-inputicon class="cursor-pointer" (click)="searchInput.value = ''; searchFilter.set('')">
        <mat-icon>close</mat-icon>
      </p-inputicon>
    }
  </p-iconfield>

  <div class="p-4 overflow-x-auto" (window:keypress)="onKey($event)">
    <div id="swimlanes" class="flex flex-row justify-around gap-4" cdkDropListGroup>
      @for (state of allStatus; track state) {
        <div
          class="bg-neutral-800 rounded-sm p-2 flex flex-col gap-2 w-full"
          #swimlane
          [cdkDropListAutoScrollDisabled]="false"
          [cdkDropListAutoScrollStep]="20"
          cdkDropList
          [cdkDropListData]="state"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="capitalize text-xl -m-2 p-2 mb-4 rounded-t-sm"
            [style.background-color]="state.color"
          >
            {{ 'todos.status.' + state.name | translate }}
          </div>
          @if (loadingTodos()) {
            <p-skeleton height="8rem" />
          } @else {
            @for (todo of todosByState()[state.name]; track todo._id; let i = $index) {
              <div
                class="todocard relative p-2 bg-neutral-900 rounded-sm cursor-pointer"
                (click)="openTodo(todo)"
                [class.selected]="
                  selectedTodo() != undefined ? selectedTodo().todo._id == todo._id : false
                "
                [class.highlight]="
                  (selectedTodo()?.todo._id == todo._id && showTodoMenu()) ||
                  ((highlightedTodos()?.includes(todo._id) ?? false) &&
                    !showTodoMenu() &&
                    !isMoving())
                "
                [attr.data-todo]="todo._id"
                cdkDrag
                [cdkDragData]="todo"
                (cdkDragStarted)="startDrag($event)"
                (cdkDragEnded)="endDrag($event)"
              >
                <div
                  class="min-h-24 border-4 border-dashed border-neutral-400"
                  *cdkDragPlaceholder
                ></div>

                @if (!dragHandleDisabled) {
                  <div class="drag-handle w-6 h-6 p-2 mobile" cdkDragHandle>
                    <mat-icon>open_with</mat-icon>
                  </div>
                }

                <div
                  class="todo-priority badge noselect"
                  [style.background-color]="todo.priority.color"
                >
                  {{ 'todos.priority.' + todo.priority.name | translate }}
                </div>

                @if (todo.assignee) {
                  <div class="todo-assignee right">
                    @if (loadingUsers()) {
                      <p-skeleton height="2rem" />
                    } @else {
                      <mat-icon>account_circle</mat-icon>
                      <div>{{ userToName(todo.assignee) }}</div>
                    }
                  </div>
                }

                <div class="todo-description">{{ todo.description }}</div>
                <div class="todo-createdate text-neutral-400">
                  <mat-icon>calendar_add_on</mat-icon>
                  <div>{{ todo.createdate | date }}</div>
                </div>
                @if (todo.duedate) {
                  <div class="todo-duedate right" [style.color]="duedateWarning(todo.duedate)">
                    <mat-icon>calendar_clock</mat-icon>
                    <div>{{ todo.duedate | date }}</div>
                  </div>
                }
                <div
                  #menu
                  class="todomenu"
                  [class.show]="showTodoMenu() && selectedTodo()?.todo._id == todo._id"
                  [class.left]="todo.status.name == 'canceled'"
                >
                  <div class="menuitem" [class.selected]="selectedMenuItem() == 'priority'">
                    <mat-icon>remove</mat-icon>
                    {{ 'internal.todos.priority' | translate }}
                    <mat-icon>add</mat-icon>
                  </div>
                  <div class="menuitem" [class.selected]="selectedMenuItem() == 'move'">
                    {{ 'internal.todos.move' | translate }}
                  </div>
                </div>
                <div
                  class="todotooltip"
                  [class.show]="
                    (isMoving() || showTodoMenu()) && selectedTodo()?.todo._id == todo._id
                  "
                  [class.bottom]="tooltipPos()"
                >
                  @if (isMoving()) {
                    <div class="tooltipitem">
                      <mat-icon>arrow_back</mat-icon>
                      4
                    </div>
                    <div class="tooltipitem">
                      <mat-icon>arrow_forward</mat-icon>
                      6
                    </div>
                    <div class="tooltipitem">
                      <mat-icon>save</mat-icon>
                      5
                    </div>
                    <div class="tooltipitem">
                      <mat-icon>close</mat-icon>
                      0
                    </div>
                  }
                  @if (showTodoMenu()) {
                    <div class="tooltipitem">
                      <mat-icon>arrow_upward</mat-icon>
                      8
                    </div>
                    <div class="tooltipitem">
                      <mat-icon>arrow_downward</mat-icon>
                      2
                    </div>
                    @if (selectedMenuItem() == 'priority') {
                      <div class="tooltipitem">
                        <mat-icon>remove</mat-icon>
                        4
                      </div>
                    }
                    @if (selectedMenuItem() == 'priority') {
                      <div class="tooltipitem">
                        <mat-icon>add</mat-icon>
                        6
                      </div>
                    }
                    @if (selectedMenuItem() == 'priority') {
                      <div class="tooltipitem">
                        <mat-icon>save</mat-icon>
                        5
                      </div>
                    }
                    @if (selectedMenuItem() == 'move') {
                      <div class="tooltipitem">
                        <mat-icon>keyboard_return</mat-icon>
                        5
                      </div>
                    }
                    <div class="tooltipitem">
                      <mat-icon>close</mat-icon>
                      0
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>

  <div id="menuOverlay" [class.show]="showTodoMenu() || highlightedTodos() != undefined"></div>
</div>
